// ================================
// global.js (deduped, global-safe)
// ================================

// ---- One-time flags (so double-inclusion doesn't re-bind) ----
window.__GLOBAL_WIRED_ARIA__      = window.__GLOBAL_WIRED_ARIA__ || false;
window.__GLOBAL_BIND_MEGA_MENU__  = window.__GLOBAL_BIND_MEGA_MENU__ || false;
window.__GLOBAL_QV_INIT__         = window.__GLOBAL_QV_INIT__ || false;
window.__GLOBAL_PAGE_TRANSITION__ = window.__GLOBAL_PAGE_TRANSITION__ || false;
window.__GLOBAL_STICKY_ATC__      = window.__GLOBAL_STICKY_ATC__ || false;

// ---- Focus helpers (kept global so other scripts can call) ----
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
window.getFocusableElements = window.getFocusableElements || getFocusableElements;

// Reuse a single handlers bucket across loads
window.trapFocusHandlers = window.trapFocusHandlers || {};
const trapFocusHandlers = window.trapFocusHandlers;

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  elementToFocus && elementToFocus.focus && elementToFocus.focus();
}
window.removeTrapFocus = window.removeTrapFocus || removeTrapFocus;

function trapFocus(container, elementToFocus = container) {
  if (!container) return;
  const elements = getFocusableElements(container);
  if (!elements.length) return;

  const first = elements[0];
  const last  = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if ((event.code || '').toUpperCase() !== 'TAB') return;
    if (event.target === last && !event.shiftKey) { event.preventDefault(); first.focus(); }
    if ((event.target === container || event.target === first) && event.shiftKey) { event.preventDefault(); last.focus(); }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin',  trapFocusHandlers.focusin);

  (elementToFocus || first)?.focus?.();
}
window.trapFocus = window.trapFocus || trapFocus;

function onKeyUpEscape(event) {
  if ((event.code || '').toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest && event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  if (summaryElement) {
    summaryElement.setAttribute('aria-expanded', 'false');
    summaryElement.focus && summaryElement.focus();
  }
}
window.onKeyUpEscape = window.onKeyUpEscape || onKeyUpEscape;

// ---- Focus-visible polyfill (only if needed) ----
try {
  document.querySelector(":focus-visible");
} catch {
  (function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP','ARROWDOWN','ARROWLEFT','ARROWRIGHT','TAB','ENTER','SPACE','ESCAPE','HOME','END','PAGEUP','PAGEDOWN'];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
      if (navKeys.includes((event.code || '').toUpperCase())) mouseClick = false;
    });
    window.addEventListener('mousedown', () => { mouseClick = true; });
    window.addEventListener('focus', () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
      if (mouseClick) return;
      currentFocusedElement = document.activeElement;
      currentFocusedElement && currentFocusedElement.classList && currentFocusedElement.classList.add('focused');
    }, true);
  })();
}

// ---- Media helpers ----
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    try { video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'); } catch {}
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    try { video.contentWindow.postMessage('{"method":"pause"}', '*'); } catch {}
  });
  document.querySelectorAll('video').forEach((video) => video.pause && video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause && model.modelViewerUI.pause();
  });
}
window.pauseAllMedia = window.pauseAllMedia || pauseAllMedia;

// ---- Small helpers (global) ----
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
window.debounce = window.debounce || debounce;

function fetchConfig(type = 'json') {
  return { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` } };
}
window.fetchConfig = window.fetchConfig || fetchConfig;

function createElementFromHTML(htmlString) {
  const div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstChild;
}
window.createElementFromHTML = window.createElementFromHTML || createElementFromHTML;

// ---- Shopify Common JS ----
if (typeof window.Shopify === 'undefined') window.Shopify = {};

Shopify.bind = Shopify.bind || function (fn, scope) {
  return function () { return fn.apply(scope, arguments); }
};

Shopify.setSelectorByValue = Shopify.setSelectorByValue || function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = Shopify.addListener || function (target, eventName, callback) {
  if (!target) return;
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent && target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = Shopify.postLink || function (path, options) {
  options = options || {};
  const method = options['method'] || 'post';
  const params = options['parameters'] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = Shopify.CountryProvinceSelector || function (country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = Shopify.CountryProvinceSelector.prototype || {
  initCountry: function () {
    if (!this.countryEl) return;
    const value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function () {
    if (!this.provinceEl) return;
    const value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function () {
    if (!this.countryEl || !this.provinceEl || !this.provinceContainer) return;
    const opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt?.getAttribute('data-provinces') || '[]';
    let provinces = [];
    try { provinces = JSON.parse(raw) || []; } catch {}

    this.clearOptions(this.provinceEl);
    if (!provinces.length) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (let i = 0; i < provinces.length; i++) {
        const o = document.createElement('option');
        o.value = provinces[i][0];
        o.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(o);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (selector) {
    if (!selector) return;
    while (selector.firstChild) selector.removeChild(selector.firstChild);
  },
  setOptions: function (selector, values) {
    if (!selector || !values) return;
    for (let i = 0; i < values.length; i++) {
      const opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

// ---- QuantityInput (custom element) ----
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }
  onButtonClick(event) {
    event.preventDefault();
    if (!this.input) return;
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);

// ---- Menu Drawer / Header Drawer ----
class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (navigator.platform === 'iPhone') {
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }
  onKeyUp(event) {
    if ((event.code || '').toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest && event.target.closest('details[open]');
    if (!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle && this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }
  onSummaryClick(event) {
    const summaryElement  = event.currentTarget;
    const detailsElement  = summaryElement.parentNode;
    const isOpen          = detailsElement.hasAttribute('open');
    const reducedMotion   = window.matchMedia("(prefers-reduced-motion: reduce)");

    const addTrapFocus = () => {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling && summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    };

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', 'true');
        (!reducedMotion || reducedMotion.matches)
          ? addTrapFocus()
          : summaryElement.nextElementSibling && summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }
  openMenuDrawer(summaryElement) {
    setTimeout(() => { this.mainDetailsToggle && this.mainDetailsToggle.classList.add('menu-opening'); });
    summaryElement && summaryElement.setAttribute('aria-expanded', 'true');
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle && this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle && this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }
  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle && this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) {
        this.closeMenuDrawer(new Event('close'));
      }
    });
  }
  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    if (detailsElement) this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary') && detailsElement.querySelector('summary').setAttribute('aria-expanded', 'false');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === undefined) animationStart = time;
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        const parentOpen = detailsElement.closest('details[open]');
        if (parentOpen) trapFocus(parentOpen, detailsElement.querySelector('summary'));
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
}
if (!customElements.get('menu-drawer')) customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  openMenuDrawer(summaryElement) {
    this.header =
      this.header ||
      document.getElementById('shopify-section-header') ||
      document.querySelector('.shopify-section-group-header-group[id$="__header"]');

    this.borderOffset = this.borderOffset ||
      (this.closest('.header-wrapper')?.classList.contains('header-wrapper--border-bottom') ? 1 : 0);

    if (this.header) {
      const b = this.header.getBoundingClientRect();
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(b.bottom - (this.borderOffset || 0))}px`);
    }

    setTimeout(() => { this.mainDetailsToggle && this.mainDetailsToggle.classList.add('menu-opening'); });
    summaryElement && summaryElement.setAttribute('aria-expanded', 'true');
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}
if (!customElements.get('header-drawer')) customElements.define('header-drawer', HeaderDrawer);

// ---- Modal Dialog / Opener ----
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]') && this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this));
    this.addEventListener('keyup', (event) => { if ((event.code || '').toUpperCase() === 'ESCAPE') this.hide(); });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => { if (event.target.nodeName === 'MODAL-DIALOG') this.hide(); });
    }
  }
  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    popup && popup.loadContent && popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    pauseAllMedia();
  }
  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    pauseAllMedia();
  }
}
if (!customElements.get('modal-dialog')) customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      modal && modal.show && modal.show(button);
    });
  }
}
if (!customElements.get('modal-opener')) customElements.define('modal-opener', ModalOpener);

// ---- Deferred Media ----
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }
  loadContent(focus = true) {
    pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      const tpl = this.querySelector('template');
      if (!tpl?.content?.firstElementChild) return;
      content.appendChild(tpl.content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', 'true');
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      focus && deferredElement && deferredElement.focus && deferredElement.focus();
    }
  }
}
if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);

// ---- Slider / Slideshow ----
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    if (!this.slider) return;

    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement   = this.querySelector('.slider-counter--total');
    this.prevButton         = this.querySelector('button[name="previous"]:not(.slider-arrow)');
    this.nextButton         = this.querySelector('button[name="next"]:not(.slider-arrow)');
    this.prevButtonArrow    = this.querySelector('button.slider-arrow[name="previous"]');
    this.nextButtonArrow    = this.querySelector('button.slider-arrow[name="next"]');

    this.initPages();
    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    if (this.nextButton && this.prevButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
    if (this.nextButtonArrow && this.prevButtonArrow) {
      this.prevButtonArrow.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButtonArrow.addEventListener('click', this.onButtonClick.bind(this));
    }
  }
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems || []).filter(el => el.clientWidth > 0);
    if (!this.sliderItemsToShow.length) {
      this.sliderLastItem = null;
      this.slidesPerPage  = 0;
      this.totalPages     = 0;
      return;
    }
    this.sliderLastItem  = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    this.slidesPerPage   = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth) || 1;
    this.totalPages      = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }
  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }
  update() {
    if (!this.sliderLastItem) return;
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent   = this.totalPages;
    }

    if (this.currentPage !== previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: { currentPage: this.currentPage, currentElement: this.sliderItemsToShow[this.currentPage - 1] }
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.prevButton) {
      this.isSlideVisible(this.sliderItemsToShow[0])
        ? this.prevButton.setAttribute('disabled', 'disabled')
        : this.prevButton.removeAttribute('disabled');
    }
    if (this.nextButton) {
      this.isSlideVisible(this.sliderLastItem)
        ? this.nextButton.setAttribute('disabled', 'disabled')
        : this.nextButton.removeAttribute('disabled');
    }
  }
  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }
  onButtonClick(event) {
    event.preventDefault();
    const step = Number(event.currentTarget.dataset.step || 1);
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth)
        : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({ left: this.slideScrollPosition });
  }
}
if (!customElements.get('slider-component')) customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping  = true;

    if (!this.slider || !this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow?.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }
  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = (Number(this.slider?.dataset?.speed) || 0) * 1000;
    if (!this.sliderAutoplayButton || !this.autoplaySpeed) return;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover',  this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin',    this.focusInHandling.bind(this));
    this.addEventListener('focusout',   this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }
  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide  = this.currentPage === this.sliderItemsToShow.length;
    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({ left: this.slideScrollPosition });
  }
  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    if (this.prevButton) this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;
    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    const active = this.sliderControlButtons[this.currentPage - 1];
    if (active) {
      active.classList.add('slider-counter__link--active');
      active.setAttribute('aria-current', 'true');
    }
  }
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }
  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || (this.sliderAutoplayButton && this.sliderAutoplayButton.contains(event.target));
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }
  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || (this.sliderAutoplayButton && this.sliderAutoplayButton.contains(event.target));
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }
  play() {
    this.slider && this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }
  pause() {
    this.slider && this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }
  togglePlayButtonState(pauseAutoplay) {
    if (!this.sliderAutoplayButton || !window.accessibilityStrings) return;
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }
  autoRotateSlides() {
    const width = this.slider?.querySelector('.slideshow__slide')?.clientWidth || 0;
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + width;
    this.slider.scrollTo({ left: slideScrollPosition });
  }
  setSlideVisibility() {
    (this.sliderItemsToShow || []).forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        button && button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        button && button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }
  linkToSlide(event) {
    event.preventDefault();
    const width = this.sliderFirstItemNode?.clientWidth || 0;
    const idx = this.sliderControlLinksArray.indexOf(event.currentTarget);
    const slideScrollPosition = this.slider.scrollLeft + width * (idx + 1 - this.currentPage);
    this.slider.scrollTo({ left: slideScrollPosition });
  }
}
if (!customElements.get('slideshow-component')) customElements.define('slideshow-component', SlideshowComponent);

// ---- Variant Selects / Radios ----
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.updateOptions(); // initial
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  updateOptions() {
    const selects = this.querySelectorAll('select');
    this.options = Array.from(selects, (select) => select.value);
    const currentOptions = this.options?.slice() || [];

    selects.forEach(function (selection, index1) {
      selection.querySelectorAll('option').forEach(function (option) {
        const thisValue   = option.value;
        const thisOptions = [];
        currentOptions.forEach(function (item, index) {
          thisOptions[index] = (index === index1) ? thisValue : currentOptions[index];
        });
        const jsonNode = selection.closest('variant-selects')?.querySelector('[type="application/json"]');
        let matchedVariant;
        try {
          const variants = JSON.parse(jsonNode?.textContent || '[]');
          matchedVariant = variants.find((variant) => {
            return !variant.options.map((opt, i) => thisOptions[i] === opt).includes(false);
          });
        } catch {}
        if (!matchedVariant || matchedVariant.available) {
          option.innerHTML = option.value;
        } else {
          option.innerHTML = option.value + ' - Sold Out';
        }
      });
    });
  }
  updateMasterId() {
    const data = this.getVariantData();
    this.currentVariant = data.find((variant) => {
      return !variant.options.map((opt, i) => this.options[i] === opt).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant?.featured_media) return;
    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery && mediaGallery.setActiveMedia && mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent && modalContent.querySelector && modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    if (modalContent && newMediaModal) modalContent.prepend(newMediaModal);
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    const base = this.dataset.url || window.location.pathname;
    window.history.replaceState({}, '', `${base}?variant=${this.currentVariant.id}`);
  }
  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    const shopUrl = window.shopUrl || window.location.origin;
    shareButton.updateUrl && shareButton.updateUrl(`${shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const root = this.closest('#quick-options-drawer') || document;
    const productForms = root.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input && this.currentVariant) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability && pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;
    const productForm = section.querySelector('product-form');
    productForm && productForm.handleErrorMessage && productForm.handleErrorMessage();
  }
  renderProductInfo() {
    const root = this.closest('#quick-options-drawer') || document;
    const url  = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const priceId   = `price-${this.dataset.section}`;
        const priceDest = root.querySelector(`#${CSS.escape(priceId)}`);
        const priceSrc  = html.getElementById(priceId);
        if (priceSrc && priceDest) priceDest.innerHTML = priceSrc.innerHTML;
        priceDest && priceDest.classList && priceDest.classList.remove('visibility-hidden');

        const invId   = `product__inventory_status-${this.dataset.section}`;
        const invDest = root.querySelector(`#${CSS.escape(invId)}`);
        const invSrc  = html.getElementById(invId);
        if (invSrc && invDest) invDest.innerHTML = invSrc.innerHTML;

        if (!root.matches('#quick-options-drawer')) {
          const stickyId  = `sticky-price-${this.dataset.section}`;
          const stickyDst = root.querySelector(`#${CSS.escape(stickyId)}`);
          const stickySrc = html.getElementById(stickyId);
          if (stickySrc && stickyDst) stickyDst.innerHTML = stickySrc.innerHTML;
          stickyDst && stickyDst.classList && stickyDst.classList.remove('visibility-hidden');
        }

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings?.soldOut);
      });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const root = this.closest('#quick-options-drawer') || document;

    const productForm = root.querySelector(`#product-form-${this.dataset.section}`);
    if (!productForm) return;

    const addButton     = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text && addButtonText) addButtonText.textContent = text;
      const wrap = productForm.querySelector('.product-form__buttons-wrapper');
      wrap && wrap.classList && wrap.classList.add('disabled');
    } else {
      addButton.removeAttribute('disabled');
      if (addButtonText) addButtonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
      const wrap = productForm.querySelector('.product-form__buttons-wrapper');
      wrap && wrap.classList && wrap.classList.remove('disabled');
    }

    if (!root.matches('#quick-options-drawer')) {
      const stickyAddButton = document.querySelector('.sticky-product-form__submit');
      if (stickyAddButton) {
        if (disable) {
          stickyAddButton.setAttribute('disabled', 'disabled');
          stickyAddButton.classList.add('disabled');
          if (text) stickyAddButton.textContent = text;
        } else {
          stickyAddButton.removeAttribute('disabled');
          stickyAddButton.classList.remove('disabled');
          stickyAddButton.textContent = window.variantStrings?.addToCart || 'Add to cart';
        }
      }
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const form = document.getElementById(`product-form-${this.dataset.section}`);
    if (!form) return;
    const addButton     = form.querySelector('[name="add"]');
    const addButtonText = form.querySelector('[name="add"] > span');
    const price         = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    if (addButtonText) addButtonText.textContent = window.variantStrings?.unavailable || 'Unavailable';
    price && price.classList && price.classList.add('visibility-hidden');
  }
  getVariantData() {
    if (!this.variantData) {
      try {
        this.variantData = JSON.parse(this.querySelector('[type="application/json"]')?.textContent || '[]');
      } catch { this.variantData = []; }
    }
    return this.variantData;
  }
}
if (!customElements.get('variant-selects')) customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) =>
      Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value
    );
    const currentOptions = this.options?.slice() || [];

    fieldsets.forEach(function (selection, index1) {
      selection.querySelectorAll('input').forEach(function (option) {
        const thisValue   = option.value;
        const thisOptions = [];
        currentOptions.forEach(function (item, index) {
          thisOptions[index] = (index === index1) ? thisValue : currentOptions[index];
        });

        const jsonNode = selection.closest('variant-radios')?.querySelector('[type="application/json"]');
        let matchedVariant;
        try {
          const variants = JSON.parse(jsonNode?.textContent || '[]');
          matchedVariant = variants.find((variant) => {
            return !variant.options.map((opt, i) => thisOptions[i] === opt).includes(false);
          });
        } catch {}

        if (!matchedVariant || matchedVariant.available) {
          option.classList.remove('disabled');
        } else {
          option.classList.add('disabled');
        }
      });
    });
  }
}
if (!customElements.get('variant-radios')) customElements.define('variant-radios', VariantRadios);

// ---- Sticky Header ----
class StickyHeader extends HTMLElement {
  constructor() { super(); }
  connectedCallback() {
    this.header =
      document.getElementById('shopify-section-header') ||
      document.querySelector('.shopify-section-group-header-group[id$="__header"]');
    if (this.header) this.header.classList.add('shopify-section-header-sticky');

    this.headerBounds     = {};
    this.currentScrollTop = 0;
    this.preventReveal    = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler     = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp= () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    if (!this.header) return;
    const observer = new IntersectionObserver((entries, ob) => {
      this.headerBounds = entries[0].intersectionRect;
      ob.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    // reveal/hide logic intentionally disabled as in your original
    this.currentScrollTop = scrollTop;
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header?.querySelectorAll?.('details-disclosure') || [];
    this.disclosures.forEach(disclosure => disclosure.close && disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || (this.header && this.header.querySelector && this.header.querySelector('details-modal'));
    this.searchModal && this.searchModal.close && this.searchModal.close(false);
  }
}
if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

// ---- Global load / sizing ----
window.addEventListener('load', () => {
  document.body.classList.add('loaded');
});

(function setWindowWidthVar() {
  const setVar = () => {
    document.documentElement.style.setProperty('--window-width', `${Math.round(document.body.clientWidth)}px`);
  };
  setVar();
  window.addEventListener('resize', setVar);
})();

// ---- Global click handlers for mega menu / menu drawer ----
if (!window.__GLOBAL_BIND_MEGA_MENU__) {
  window.__GLOBAL_BIND_MEGA_MENU__ = true;
  window.addEventListener('DOMContentLoaded', () => {
    document.body.addEventListener('click', (event) => {
      // Mega-menu close when clicking outside
      if (!event.target.closest('.mega-menu')) {
        const openMega = document.querySelector('details.mega-menu[open]');
        if (openMega) {
          const hw = openMega.closest('.header-wrapper');
          hw && hw.classList && hw.classList.remove('mega-menu-opened');
          openMega.removeAttribute('open');
        }
      }
      // Menu-drawer close when clicking outside
      if (!event.target.closest('.menu-drawer-container')) {
        const openDrawer  = document.querySelector('details.menu-drawer-container[open]');
        const closeSummary= openDrawer && openDrawer.querySelector('summary[aria-controls="menu-drawer"]');
        closeSummary && closeSummary.click && closeSummary.click();
      }
    });
  });
}

// ---- QUICK-VIEW: fetch PDP HTML and open the drawer ----
if (!window.__GLOBAL_QV_INIT__) {
  window.__GLOBAL_QV_INIT__ = true;
  window.addEventListener('DOMContentLoaded', () => {
    const quickOptions = document.querySelectorAll('.button-quick-options');
    let lastQuickViewOpener = null;

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const drawer = document.getElementById('quick-options-drawer');
        if (drawer && drawer.classList.contains('open')) {
          drawer.classList.remove('open');
          document.body.classList.remove('quick-options-open');
          removeTrapFocus(lastQuickViewOpener);
        }
      }
    });

    quickOptions.forEach((btn) => {
      if (btn.dataset.qvBound === '1') return;
      btn.dataset.qvBound = '1';

      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        lastQuickViewOpener = btn;

        const handle = btn.getAttribute('data-handle');
        const link   = '/products/' + handle;

        fetch(link)
          .then((res) => res.text())
          .then((html) => {
            const parser      = new DOMParser();
            const productDoc  = parser.parseFromString(html, 'text/html');
            if (!productDoc) return;

            const productContent = productDoc.querySelector('.shopify-section.product-section');
            if (!productContent) return;

            productContent.querySelector('.sticky-addtocart-wrapper')?.remove();

            let drawer = document.getElementById('quick-options-drawer');
            if (!drawer) {
              drawer = document.createElement('div');
              drawer.id = 'quick-options-drawer';
              drawer.className = 'quick-options-drawer';

              const inner   = document.createElement('div');
              inner.className = 'quick-options-drawer-inner';
              const overlay = document.createElement('div');
              overlay.className = 'quick-options-drawer-overlay';
              const close   = document.createElement('div');
              close.className   = 'quick-options-drawer-close';

              drawer.append(inner, overlay, close);
              document.body.appendChild(drawer);

              const closeDrawer = () => {
                drawer.classList.remove('open');
                document.body.classList.remove('quick-options-open');
                removeTrapFocus(lastQuickViewOpener);
              };
              overlay.addEventListener('click', closeDrawer);
              close.addEventListener('click', closeDrawer);
            } else {
              drawer.querySelector('.quick-options-drawer-inner').innerHTML = '';
            }

            productContent.querySelector('variant-radios')?.setAttribute('data-update-url', 'false');
            productContent.querySelector('variant-selects')?.setAttribute('data-update-url', 'false');
            productContent.querySelectorAll('.slider--mobile').forEach((el) => el.classList.add('slider--tablet-up'));

            drawer.querySelector('.quick-options-drawer-inner').appendChild(productContent);
            drawer.classList.add('open');
            document.body.classList.add('quick-options-open');

            drawer.setAttribute('role', 'dialog');
            drawer.setAttribute('aria-modal', 'true');
            const panel = drawer.querySelector('.quick-options-drawer-inner');
            const initialFocus =
              panel.querySelector('[name="add"]') ||
              panel.querySelector('select') ||
              panel.querySelector('button,[href],input,textarea,[tabindex]:not([tabindex^="-"])') ||
              panel;
            trapFocus(drawer, initialFocus);

            try { Shopify.PaymentButton && Shopify.PaymentButton.init && Shopify.PaymentButton.init(); } catch {}

            setTimeout(() => {
              const buyItNow = drawer.querySelector('.shopify-payment-button__button');
              if (!buyItNow) return;
              buyItNow.removeAttribute('disabled');
              buyItNow.addEventListener('click', function (evt) {
                evt.preventDefault();
                const form   = buyItNow.closest('form');
                const config = { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' } };
                const formData = new FormData(form);
                formData.append('sections_url', window.location.pathname);
                config.body = formData;

                fetch('/cart/clear.js')
                  .then(() => fetch(`${(window.routes || {}).cart_add_url || '/cart/add.js'}`, config))
                  .then((res) => res.json())
                  .then((response) => {
                    if (response?.status) return;
                    drawer.classList.remove('open');
                  })
                  .catch(console.error)
                  .finally(() => { window.location.href = '/checkout'; });
              });
            }, 1000);

            drawer.dispatchEvent(new Event('quickview:opened'));
          });
      });
    });
  });

  document.addEventListener('quickview:opened', function () {
    if (typeof window.productImageDesktopArrow === 'function') {
      try { window.productImageDesktopArrow(); } catch {}
    }
  });
}

// ---- Page transition animation ----
if (!window.__GLOBAL_PAGE_TRANSITION__) {
  window.__GLOBAL_PAGE_TRANSITION__ = true;

  window.addEventListener('DOMContentLoaded', () => {
    document.body.classList.remove('loading');
    document.body.classList.add('loaded');

    const anchors = document.getElementsByTagName('a');
    for (let idx = 0; idx < anchors.length; idx += 1) {
      const a = anchors[idx];
      if (a.hostname !== window.location.hostname) continue;
      if (document.querySelector('cart-drawer') && a.pathname.indexOf('/cart') !== -1) continue;
      if (a.classList.contains('button--cart-item-remove')) continue;
      if (a.getAttribute('href') === '#' || a.getAttribute('href') === '') continue;
      a.addEventListener('click', function () { document.body.classList.add('unloading'); });
    }
  });
  window.onbeforeunload = function () { document.body.classList.add('unloading'); };
  window.addEventListener("pageshow", function () { document.body.classList.remove('unloading'); });
}

// ---- PRODUCT PAGE: Sticky Add To Cart ----
function stickyAddToCartPosition() {
  const stickyAddToCartWrapper = document.querySelector('.sticky-addtocart-wrapper');
  if (!stickyAddToCartWrapper) return;

  const addToCartButton = document.querySelector('.product__info-wrapper .product-form button[name="add"]');
  if (!addToCartButton) return;

  const addToCartButton_offsetTop = addToCartButton.offsetTop;
  const doc = document.documentElement;
  const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  if (top > addToCartButton_offsetTop + 100) {
    stickyAddToCartWrapper.classList.add('active');
  } else {
    stickyAddToCartWrapper.classList.remove('active');
  }
}

if (!window.__GLOBAL_STICKY_ATC__) {
  window.__GLOBAL_STICKY_ATC__ = true;

  window.addEventListener('DOMContentLoaded', () => {
    const stickyAddToCartWrapper = document.querySelector('.sticky-addtocart-wrapper');
    if (stickyAddToCartWrapper) {
      const stickAddButton = document.querySelector('.sticky-product-form__submit');
      if (stickAddButton) {
        stickAddButton.addEventListener('click', () => {
          const addToCartButton = document.querySelector('.product__info-wrapper .product-form button[name="add"]');
          if (!addToCartButton) return;
          const y = addToCartButton.offsetTop;
          window.scrollTo({ top: y - window.innerHeight + 100, behavior: 'smooth' });
        });
      }
      const footer = document.querySelector('footer');
      if (footer) footer.style.marginBottom = stickyAddToCartWrapper.offsetHeight + 'px';
      stickyAddToCartPosition();
    }
  });

  window.addEventListener('resize', () => {
    const stickyAddToCartWrapper = document.querySelector('.sticky-addtocart-wrapper');
    if (stickyAddToCartWrapper) {
      const footer = document.querySelector('footer');
      if (footer) footer.style.marginBottom = stickyAddToCartWrapper.offsetHeight + 'px';
    }
  });

  window.addEventListener('scroll', stickyAddToCartPosition);
}

// ---- Details Summary ARIA wiring (single pass) ----
if (!window.__GLOBAL_WIRED_ARIA__) {
  window.__GLOBAL_WIRED_ARIA__ = true;

  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', 'false');

    const next = summary.nextElementSibling;
    if (next && next.id) summary.setAttribute('aria-controls', next.id);

    summary.addEventListener('click', (event) => {
      const details = event.currentTarget.closest && event.currentTarget.closest('details');
      const isOpen  = details && details.hasAttribute('open');
      event.currentTarget.setAttribute('aria-expanded', String(!isOpen));
    });

    if (!summary.closest('header-drawer')) {
      summary.parentElement && summary.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
  });
}
document.addEventListener('click', function(e) {

  const addButton = e.target.closest(
    'button[name="add"], .product-form__submit, .add-to-cart'
  );

  if (!addButton) return;

  const form = addButton.closest('form');

  if (!form) return;

  const variantInput = form.querySelector('input[name="id"]');

  const productId = variantInput ? variantInput.value : '';

  let productPrice = '';
  let productName = '';

  const productContainer = addButton.closest('.product, .card, .product-card, .quick-options-drawer');

  if (productContainer) {

    const titleEl = productContainer.querySelector(
      '.product__title, .card-information__text, h1, h2, h3'
    );

    if (titleEl) {
      productName = titleEl.innerText.trim();
    }

    const priceEl = productContainer.querySelector(
      '.price-item--regular, .price, .money'
    );

    if (priceEl) {
      productPrice = priceEl.innerText.replace(/[^0-9.]/g, '');
    }
  }

  window.dataLayer = window.dataLayer || [];

  dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      items: [{
        item_id: productId,
        item_name: productName,
        price: productPrice
      }]
    }
  });

  console.log('Add To Cart DataLayer:', {
    item_id: productId,
    item_name: productName,
    price: productPrice
  });

});